export default "__VITE_ASSET__Xlc3_7XT__"